// extracted by mini-css-extract-plugin
module.exports = {"button":"ShopifyMiniCart_button__E5t3t","sheet":"ShopifyMiniCart_sheet___kzDu","sheetFooter":"ShopifyMiniCart_sheetFooter__2P27p"};